import { render, staticRenderFns } from "./ModalAssignCollaboratorsToCompanies.vue?vue&type=template&id=5d177411&scoped=true"
import script from "./ModalAssignCollaboratorsToCompanies.vue?vue&type=script&lang=js"
export * from "./ModalAssignCollaboratorsToCompanies.vue?vue&type=script&lang=js"
import style0 from "./ModalAssignCollaboratorsToCompanies.vue?vue&type=style&index=0&id=5d177411&prod&scoped=true&lang=css"
import style1 from "./ModalAssignCollaboratorsToCompanies.vue?vue&type=style&index=1&id=5d177411&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d177411",
  null
  
)

export default component.exports